import { salesforceAssignmentSlug, salesforceOrderSlug } from 'constants/staticLinks'

export const getSalesforceAssignmentLink = (salesforceId: string) => `${process.env.REACT_APP_SALESFORCE_BASE_URL}/${salesforceAssignmentSlug.replace('{salesforceId}', salesforceId)}`
export const getSalesforceOrderLink = (salesforceId: string) => `${process.env.REACT_APP_SALESFORCE_BASE_URL}/${salesforceOrderSlug.replace('{salesforceId}', salesforceId)}`
